import { render, staticRenderFns } from "./DispatchConfirmationModal.vue?vue&type=template&id=8c515f72&"
import script from "./DispatchConfirmationModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DispatchConfirmationModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports